import SoftBadge from "modules/common/SoftBadge";
import { currentUser } from "./utility";
import secureLocalStorage from "react-secure-storage";

export const LEAD_AGENT = ["00000000-0000-0000-0000-000000000032"];
export const IVR_AGENT = ["00000000-0000-0000-0000-000000000015"];

export const validateUrl = ["vayuskin", "technotask", "corp", "concentrix","Fusioncx", "squadstack", "finnoto", "gmail", "voitekk", "maxicus", 'fusioncx', "radmintec", "radicalminds", "drit", "mail", "jsw", "ileadsemail", "internal", "partner"];

export const quotes = [
  "Success in the workplace is not about the job you do, it's about the impact you make.",
  "The only way to do great work is to love what you do. If you haven't found it yet, keep looking. Don't settle.",
  "The future belongs to those who believe in the beauty of their dreams.",
  "Opportunities don't happen. You create them.",
  "The only limit to our realization of tomorrow will be our doubts of today.",
  "Don't watch the clock; do what it does. Keep going.",
  "The best way to predict the future is to create it.",
  "Success is not final, failure is not fatal: It is the courage to continue that counts.",
  "Your time is limited, don't waste it living someone else's life.",
  "The harder you work for something, the greater you'll feel when you achieve it.",
  "Believe you can and you're halfway there.",
  "The only place where success comes before work is in the dictionary.",
  "Success is walking from failure to failure with no loss of enthusiasm.",
  "Don't be pushed around by the fears in your mind. Be led by the dreams in your heart.",
  "You miss 100% of the shots you don't take.",
  "The biggest risk is not taking any risk. In a world that's changing really quickly, the only strategy that is guaranteed to fail is not taking risks.",
  "The road to success and the road to failure are almost exactly the same.",
  "I find that the harder I work, the more luck I seem to have.",
  "Dream big and dare to fail.",
  "The only person you should try to be better than is the person you were yesterday.",
];


export function getTag(record) {
  if (record.is_auto_finished) {
    return "AUTO FINISHED";
  } else if (record.is_finished) {
    return "FINISHED";
  } else if (record.is_rescheduled) {
    if (
      record.reschedule_count &&
      record.reschedule_count >= record.unanswered_count
    ) {
      return "RESCHEDULED";
    } else if (
      record.reschedule_count &&
      record.reschedule_count < record.unanswered_count
    ) {
      return "NOT ANSWERED";
    } else {
      return "NOT ANSWERED";
    }
  } else if (record.unanswered_count && record.unanswered_count > 0) {
    return "NOT ANSWERED";
  } else if (record.is_user_booked) {
    return "NOT FINISHED";
  }
}

export const MARKING_DELIVERY_ACCESS = [
  "tejasdoiphode@traya.health",
  "nirajsurve@traya.health",
  "suhashdsouza@traya.health",
  "agarwalsandip@traya.health",
  "sandip@traya.health",
  "nirbhay@trayahealth.com",
  "nikhilsavant@traya.health",
  "kaustubhbelwalkar@traya.health"
]

export const POP_ACCESS =[
  "admin",
  "super_admin",
  "doctor_admin",
  "operations_admin",
  "doctor_admin",
  "clinic_doctor",
  "clinic_receptionist"
];

export const RECEPTIONIST_EXECUTIVE = [  "00000000-0000-0000-0000-000000000034", "00000000-0000-0000-0000-000000000035"];
export const RECEPTIONINST =  ['clinic_receptionist', 'doctor'].includes(currentUser);

export const OMS_ACCESS = [
  "aniket@traya.health",
  "agarwalsandip@traya.health",
  "nirbhay@traya.health", // For prod checking
  "nirbhay@trayahealth.com", // For dev checking
  "adarshchourasia@traya.health"
].includes(secureLocalStorage.getItem("email"));